/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `general` - General franchise
 * * `special` - Special franchise
 */
export enum FranchiseEnum {
  GENERAL = 'general',
  SPECIAL = 'special',
}
